@if (refreshing) {
<mat-spinner class="spinner" name="crescent"></mat-spinner>
} @if (!refreshing && data.length > 0) {
<div class="table-data-wrapper"
  [ngClass]="{ 'table-data-flex': options.flexCardLayout === true && layoutService.screenSize > breakpoint }">
  @if (tableHeaders != null) {
  <app-card-table-header [ngClass]="{
      'table-data-flex-card': options.flexCardLayout === true && layoutService.screenSize > breakpoint,
      'hide-table': isPagingComplete == false
    }" [row]="{ $implicit: tableHeaders }" [options]="options" [prefixTemplate]="prefixTemplate"
    [headers]="tableHeaders" [cardTemplate]="cardTemplate" [rowTemplate]="rowTemplate" [affixTemplate]="affixTemplate"
    (selectedEvent)="selectAll($event)" (sortedEvent)="sort($event)" [breakpoint]="breakpoint"
    [sortedIndex]="sortedIndex" [originalStyling]="originalStyling">
  </app-card-table-header>
  } @for ( row of data | paginate : {id:"id"+uniqueID, itemsPerPage: 10, currentPage: currentPage, totalItems:
  totalItems }; track row;
  let i = $index) {
  <app-card-table-row [ngClass]="{
      'table-data-flex-card': options.flexCardLayout === true && layoutService.screenSize > breakpoint,
      'hide-table': isPagingComplete == false
    }" [attr.data-index]="i" [row]="{ $implicit: row, index: i }" [options]="options" [prefixTemplate]="prefixTemplate"
    [headers]="tableHeaders" [isExpandable]="isExpandable" [cardTemplate]="cardTemplate" [rowTemplate]="rowTemplate"
    [affixTemplate]="affixTemplate" [dropDownActionsTemplate]="dropDownActionsTemplate"
    [dropDownDataKey]="dropDownDataKey" [expansionHeader]="expansionHeader" (selectedEvent)="selected($event)"
    [breakpoint]="breakpoint" [originalStyling]="originalStyling" [isSelected]="row.selected">
  </app-card-table-row>
  }
</div>
}
@if (enableTablePagination && isPagingComplete && data.length > 0 && !refreshing) {
<pagination-controls [id]="'id'+uniqueID" (pageChange)="onChangePage($event)" class="pagination">
</pagination-controls>
}